import { useEffect } from 'react';
import { PublicKey } from '@solana/web3.js';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import BigNumber from 'bignumber.js';
import { useAppStore } from '@/store';
import connection from '@/lib/connection';

export const useSolAmountChange = () => {
  const { setChainCoinBalance } = useAppStore();
  const { walletAddress, chain } = useBoomWallet();
  useEffect(() => {
    setChainCoinBalance('0');
    if (!walletAddress || chain !== 'solana') return;
    const pubkey = new PublicKey(walletAddress);
    const subId = connection.onAccountChange(
      pubkey,
      (account) => {
        if (account !== null) {
          const solBalance = BigNumber(account.lamports).div(1e9).toFixed();
          setChainCoinBalance(solBalance);
        }
      },
      { commitment: 'confirmed', encoding: 'base64' },
    );

    connection.getParsedAccountInfo(pubkey).then((info) => {
      if (info.value?.lamports) {
        const solBalance = BigNumber(info.value?.lamports as number)
          .div(1e9)
          .toFixed();
        setChainCoinBalance(solBalance);
      }
    });
    return () => {
      connection.removeAccountChangeListener(subId);
    };
  }, [walletAddress, chain]);
};
